import { useSuspenseQuery } from '@tanstack/react-query';
import { getDailyUsage } from '../api/DashboardApi';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { dashboardQueries } from '../queries/dashboardQueries';
import { mapUsageDTOtoAreaChartData } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { useTranslation } from 'react-i18next';

type UseTariffSummaryCumulativeUsageDataProps = {
  accountRef: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

export const useDailyUsageData = ({
  accountRef,
  chartType,
  usageType,
}: UseTariffSummaryCumulativeUsageDataProps) => {
  const { t } = useTranslation();

  const { data } = useSuspenseQuery<
    Awaited<ReturnType<typeof getDailyUsage>>,
    Error,
    ReturnType<typeof mapUsageDTOtoAreaChartData>
  >({
    queryKey: dashboardQueries.dailyUsage({
      accountRef,
      chartType,
      usageType,
    }),
    queryFn: () => setMinimalPromiseTime(getDailyUsage({ accountRef, chartType, usageType })),
    select: (chartData) => mapUsageDTOtoAreaChartData(chartData, usageType, t),
  });
  return data;
};
